import {Fragment, FunctionComponent} from 'react';
import {NavLink, Outlet} from 'react-router-dom';
import {IcLogoSmall} from '../../core/constant';
import {MUI} from '@verihubs/pandora';

const {Container} = MUI;

export const LandingTemplate: FunctionComponent = (): JSX.Element => {
  return (
    <Fragment>
      <Container maxWidth="md" className="py-10">
        <NavLink to="/">
          <figure className="w-32">
            <img alt="Verihubs Icon" src={IcLogoSmall} className="w-full" />
          </figure>
        </NavLink>
      </Container>
      <Outlet />
    </Fragment>
  );
};
